// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__OfeGt","xs":"spinner_xs__sKBK+","sm":"spinner_sm__Qn+OH","md":"spinner_md__SO3jL","lg":"spinner_lg__ufDz6"};